import lodash from "lodash";
import {
    createFieldDate,
    createFieldInput,
    createFieldInputNumber,
    createFieldSelect,
    createFieldTemplateBuilder
} from "../../../../../components/input/template-builder/template-builder.logic";
import { createColumnImageUrl, createColumnInput, createColumnInputNumber } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { createFieldRegister1, callJobPosition, callDepartment, callSubDepartment, callEducation, callMainOccupation, callSecondOccupation } from "../../../../../views/account/register/register.section";
import { createField as createFieldNameUser } from "../../../../../views/account/modal/user-modal/user-modal.logic";
import { createField as createFieldAttach } from "../../../../../views/account/verify-identity-file/verify-identity-file.section";
import { createFieldAttachment } from "../../../../../components/input/template-builder/template-builder.logic";

export const callTitle = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "TITLE", value: searchQuery });

export const callRole = ({ searchQuery }) =>
    store.dispatch("resource/v1/security/role/cacheFindAllIsDefaultFalse", { searchQuery }).then(items => items.map(item => ({ refRole: item })));

export const createColumns = () => {
    const columns = [
        createColumnImageUrl({ title: () => i18n.global.t("model.user.refImage"), dataIndex: "refImage.url" }),
        // createColumnInput({ title: () => i18n.global.t("model.user.username"), dataIndex: "username" }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.user.idCard"),
            dataIndex: "idCard",
            comma: false,
            inputProp: () => ({ comma: false })
        }),
        createColumnInput({ title: () => i18n.global.t("model.user.fullNameTh"), dataIndex: "fullNameTh", width: 200 }),
        createColumnInput({ title: () => i18n.global.t("model.user.mobile"), dataIndex: "mobile" }),
        createColumnInput({ title: () => i18n.global.t("model.user.email"), dataIndex: "email" })
    ];
    return columns;
};

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldRegister1({ props, data, key }),
            ...createFieldNameUser({ props, data, key }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldDate({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}birthDate`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.birthDateRegister"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    { value: model.birthDate, "onUpdate:value": (value) => (model.birthDate = value), disabled: viewOnly },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldDate({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}expireDate`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.expireDateRegister"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    { value: model.expireDate, "onUpdate:value": (value) => (model.expireDate = value), disabled: viewOnly },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}email`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.email"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.email,
                                        "onUpdate:value": (value) => {
                                            model.email = value;
                                        },
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldInputNumber({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}mobile`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.mobile"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.mobile,
                                        "onUpdate:value": (value) => (model.mobile = value),
                                        comma: false,
                                        disabled: viewOnly,
                                        maxDecimal: 10,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}positionCode`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.positionCode"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.positionCode,
                                        "onUpdate:value": (value) => (model.positionCode = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refPosition`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.refPosition"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refPosition,
                                        "onUpdate:value": (value) => (model.refPosition = value),
                                        disabled: viewOnly,
                                        list: callJobPosition,
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refDepartment`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.register.refDepartment"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refDepartment,
                                        "onUpdate:value": (value) => {
                                            model.refDepartment = value;
                                            model.refSubDepartment = null;
                                        },
                                        disabled: viewOnly,
                                        list: callDepartment,
                                        optLabel: "nameTh",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refSubDepartment`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.register.refSubDepartment"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refSubDepartment,
                                        "onUpdate:value": (value) => (model.refSubDepartment = value),
                                        disabled: !model.refDepartment || viewOnly,
                                        list: ({ searchQuery }) => callSubDepartment({ searchQuery, parentId: model.refDepartment.id }),
                                        optLabel: "nameTh",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldDate({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}registerDate`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.registerDate"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    { value: model.registerDate, "onUpdate:value": (value) => (model.registerDate = value), disabled: viewOnly },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldInputNumber({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}registerCapital`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.registerCapital"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.registerCapital,
                                        "onUpdate:value": (value) => (modelRef.registerCapital = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}idLine`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.idLine"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.idLine,
                                        "onUpdate:value": (value) => (model.idLine = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refEducation`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.refEducation"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refEducation,
                                        "onUpdate:value": (value) => (model.refEducation = value),
                                        disabled: viewOnly,
                                        list: ({ searchQuery }) => callEducation({ searchQuery }),
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refMainOccupation`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.refMainOccupation"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refMainOccupation,
                                        "onUpdate:value": (value) => (model.refMainOccupation = value),
                                        disabled: viewOnly,
                                        list: ({ searchQuery }) => callMainOccupation({ searchQuery }),
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refSecondOccupation`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.refSecondOccupation"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refSecondOccupation,
                                        "onUpdate:value": (value) => (model.refSecondOccupation = value),
                                        disabled: viewOnly,
                                        list: ({ searchQuery }) => callSecondOccupation({ searchQuery }),
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
            // createFieldImage({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}refImage`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 6, xl: 4 } }),
            //     label: () => i18n.global.t("model.user.refImage"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 value: model.refImage,
            //                 "onUpdate:value": value => (model.refImage = value),
            //                 group: "Image",
            //                 disabled: viewOnly
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            // createFieldInput({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}username`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.user.username"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             { value: model.username, "onUpdate:value": value => (model.username = value), disabled: viewOnly || !!model.id },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            // createFieldSelect({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}refTitle`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.user.refTitle"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 value: model.refTitle,
            //                 "onUpdate:value": value => (model.refTitle = value),
            //                 disabled: viewOnly,
            //                 list: callTitle,
            //                 optLabel: "value"
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         ),
            //     changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            // }),
            // createFieldInput({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}firstNameTh`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.user.firstNameTh"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             { value: model.firstNameTh, "onUpdate:value": value => (model.firstNameTh = value), disabled: viewOnly },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            // // createFieldInput({
            // //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            // //     key: `${prefix}middleNameTh`,
            // //     colProp: () => ({ xs: 24 }),
            // //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            // //     label: () => i18n.global.t("model.user.middleNameTh"),
            // //     inputProp: ({ field }) =>
            // //         lodash.merge(
            // //             { value: model.middleNameTh, "onUpdate:value": value => (model.middleNameTh = value), disabled: viewOnly },
            // //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            // //         )
            // // }),
            // createFieldInput({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}lastNameTh`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.user.lastNameTh"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             { value: model.lastNameTh, "onUpdate:value": value => (model.lastNameTh = value), disabled: viewOnly },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            // createFieldDate({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}birthDate`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.user.birthDate"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             { value: model.birthDate, "onUpdate:value": value => (model.birthDate = value), disabled: viewOnly },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            // createFieldInput({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}email`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.user.email"),
            //     inputProp: ({ field }) => {
            //         return lodash.merge(
            //             {
            //                 value: model.email,
            //                 "onUpdate:value": value => (model.email = value),
            //                 disabled: viewOnly,
            //                 onBlur: () => useForm.validate(field.key).catch(() => {})
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         );
            //     }
            // }),
            // createFieldInputNumber({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}idCard`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.user.idCard"),
            //     inputProp: ({ field }) => {
            //         return lodash.merge(
            //             {
            //                 value: model.idCard,
            //                 "onUpdate:value": value => (model.idCard = value),
            //                 disabled: viewOnly,
            //                 comma: false,
            //                 onBlur: () => useForm.validate(field.key).catch(() => {})
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         );
            //     }
            // }),
            // createFieldInputNumber({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}mobile`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.user.phone"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 value: model.mobile,
            //                 "onUpdate:value": value => (model.mobile = value),
            //                 disabled: viewOnly,
            //                 comma: false,
            //                 maxDecimal: 10
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            // createFieldTreeSelect({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}refDepartment`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.department.modelName"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 value: model.refDepartment,
            //                 "onUpdate:value": value => (model.refDepartment = value),
            //                 disabled: viewOnly,
            //                 list: callDepartment,
            //                 optLabel: "nameTh"
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}userRoles`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.role.modelName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.userRoles,
                            "onUpdate:value": value => (model.userRoles = value),
                            disabled: viewOnly,
                            list: callRole,
                            renderLabel: ({ item }) => (
                                <span>
                                    {item.refRole.name} ({item.refRole.desc})
                                </span>
                            ),
                            mode: "multiple",
                            optKey: "refRole.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refRole?.name }
            }),
            ...createFieldAttach({ props, data, key }),
        ]
    });
};

export const createFieldAttachmentDoc = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldAttachment({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}attachmentDocs.0`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6, lg: 4 }, wrapperCol: { xs: 24, md: 18, lg: 20 } }),
                label: () => i18n.global.t("model.user.refAttachDoc"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.attachmentDocs?.[0]?.url || model.attachmentDocs?.[0]?.blob ? model.attachmentDocs?.[0] : null,
                            "onUpdate:value": (value) => {
                                if (!model.attachmentDocs?.[0]) {
                                    model.attachmentDocs.push({});
                                }
                                const refAttach = model.attachmentDocs?.[0];
                                if(value) {
                                    refAttach.documentName = refAttach?.documentName ? refAttach?.documentName : value.name;
                                    refAttach.name = value.name;
                                    refAttach.group = value.group;
                                    refAttach.blob = value.blob;
                                    refAttach.type = value.type;
                                    refAttach.size = value.size;
                                } else {
                                    refAttach.name = null;
                                    refAttach.blob = null;
                                    refAttach.type = null;
                                    refAttach.size = null;
                                }
                                refAttach.url = null;
                                refAttach.path = null;
                                refAttach.isSave = true;

                                /* refAttach.name = value?.name;
                                refAttach.documentName = refAttach.documentName ? refAttach.documentName : value?.name;
                                refAttach.blob = value?.blob;
                                refAttach.isSave = value?.isSave;
                                refAttach.size = value?.size;
                                refAttach.type = value?.type;
                                refAttach.group = value?.group; */
                            },
                            group: "Doc",
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                },
            }),
        ],
    });
}